import { useEffect } from 'react'

const usePreventScroll = (preventScroll: boolean): void => {
  useEffect(() => {
    const rootElement = document.getElementById('root')

    if (rootElement && preventScroll) {
      // add overflow-hidden to prevent scrolling
      document.body.style.overflow = preventScroll ? 'hidden' : 'unset'
    } else if (rootElement) {
      // add overflow-auto to allow scrolling
      document.body.style.overflow = 'auto'
    }
  }, [preventScroll])
}

export default usePreventScroll
